import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'WorkOvertime/List',
        method: 'post',
        data
    })
}

/** 管理后台：管理员为机手批量手动录入 OT/中直 */
export const adminManualSaveApi = (data) => {
    return request({
        url: 'WorkOvertime/adminManualSave',
        method: 'post',
        data
    })
}

export const SummaryList = (data) => {
    return request({
        url: 'Summary/List',
        method: 'post',
        data
    })
}
export const Payslipssave = (data) => {
    return request({
        url: 'Payslips/save',
        method: 'post',
        data
    })
}
export const PayslipsList = (data) => {
    return request({
        url: 'Payslips/List',
        method: 'post',
        data
    })
}
export const PayslipsUpdate = (data) => {
    return request({
        url: 'Payslips/update',
        method: 'post',
        data
    })
}